
let imageObserver;

function observeLazyImages() {
  const lazyImages = document.querySelectorAll('img.lazy-load');

  lazyImages.forEach((img) => {
    imageObserver.observe(img);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if ('IntersectionObserver' in window) {
    imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;

          if (img.dataset.src) {
            img.src = img.dataset.src;
          }

          if (img.dataset.srcset) {
            img.srcset = img.dataset.srcset;
          }

          img.classList.remove('lazy-load');
          observer.unobserve(img);
        }
      });
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    observeLazyImages(); // initial run

    // A variant change replaces the PDP gallery nodes, so the new placeholder
    // images need observing too — otherwise they stay at their 20px src.
    document.addEventListener('gallery:updated', observeLazyImages);
  } else {
    // fallback for old browsers
    const lazyImages = document.querySelectorAll('img.lazy-load');
    lazyImages.forEach((img) => {
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.classList.remove('lazy-load');
    });
  }
});
